import { Component, Input } from '@angular/core';
import { InvoiceDetailService } from '../services/invoice.detail.service';
import { InvoiceDetail } from '../models/invoice.detail.model';
import { LookupService } from '../services/lookup.service';
import { NotificationService } from '../services/notification.service';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';

@Component({
  selector: 'app-invoice-detail-form',
  templateUrl: './invoice-detail-form.component.html'
})
export class InvoiceDetailFormComponent {
  constructor(public lookupService: LookupService, public service: InvoiceDetailService, private notificationService: NotificationService, private datepipe: DatePipe) { }

  @Input() model: InvoiceDetail;

  options: any = { format: 'YYYY-MM-DD' };
  optionsTime: any = { format: 'LT' };

  ngOnInit() {

  }


  submitted = false;

  onSubmit() {
    this.submitted = true;

    this.service.model = this.model;
    if (!this.model.invoiceDetailID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.getByInvoice();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.service.getByInvoice();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => {
        console.log(err);
      }
    )
  }

}
 
